import { Theme } from './theme'
import logoSvg from '@/assets/logoOkta.svg'

export const oktaTheme: Theme = {
  app: {
    $bgColor: '#F9F9F9',
  },
  loadingSpinner: {
    $bgColor: '#ffffff',
    spinner: {
      $color: '#1662DD',
      $bgColor: '#F1F3F7',
    },
  },
  logo: {
    $svg: logoSvg,
  },
  infoPage: {
    $showAboveTitle: true,
  },
  resetPasswordPage: {
    $showAboveTitle: true,
  },
  container: {
    $bgColor: '#FFFFFF',
    $width: '400px',
    $height: 'auto',
    $padding: '0 40px 40px 40px',
    $borderRadius: '3px',
    $border: '1px solid rgba(230, 221, 249, 1)',
    $boxShadow: '2px 2px 10px 0px rgba(0, 0, 0, 0.07)',
    $margin: '0 auto',
    $color: '#2B253A',
  },
  title: {
    $fontSize: '16px',
    $lineHeight: '36px',
    $color: '#5E5E5E',
  },
  paragraph: {
    $fontSize: '14px',
    $lineHeight: '20px',
    $color: '#5E5E5E',
  },
  label: {
    $fontSize: '14px',
    $lineHeight: '20px',
    $color: '#444746',
  },
  input: {
    $fontSize: '14px',
    $lineHeight: '20px',
    $color: '#444746',
    $padding: '10px 16px',
    $border: '1px solid #B7BDC6',
    $borderRadius: '4px',
    $error: {
      $border: '1px solid #D83535',
      $boxShadow: '0px 0px 0px 3px #FFB0B0',
      $color: '#941616',
    },
  },
  buttonsContainer: {
    $flexDirection: 'column-reverse',
    $justifyContent: 'flex-start',
    $alignItems: 'stretch',
    $gap: '20px',
  },
  button: {
    $fontSize: '14px',
    $lineHeight: '20px',
    $color: '#ffffff',
    $padding: '10px 24px',
    $border: '0px',
    $borderRadius: '3px',
    $bgColor: '#1662DD',
    $hover: {
      $color: '#ffffff',
      $border: '0px',
      $bgColor: '#1662DD',
    },
    $disabled: {
      $color: '#F6F6F6',
      $border: '0px',
      $bgColor: '#ACB0B5',
    },
  },
  link: {
    $fontSize: '14px',
    $lineHeight: '20px',
    $color: '#6E6E78',
    $border: '0px',
    $borderRadius: '0px',
    $bgColor: 'transparent',
    $textDecoration: 'underline',
    $hover: {
      $fontSize: '14px',
      $lineHeight: '20px',
      $color: '#6E6E78',
      $border: '0px',
      $borderRadius: '0px',
      $bgColor: 'transparent',
    },
  },
  breakpoints: {
    mobile: 480,
    tablet: 1024,
    desktop: 1440,
  },
}
